var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row py-4" }, [
    _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 text-center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("message.booking.complete_step.booking_success")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-4" }, [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("message.booking.complete_step.success_message01")
            )
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("message.booking.complete_step.success_message02")
            )
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3 text-info" }, [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("message.booking.complete_step.success_message03")
            )
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-info btn-block",
              attrs: { to: _vm.pageUrl }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("message.booking.complete_step.view_my_booking")
                  ) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("i", { staticClass: "fal fa-check-circle fa-7x text-success" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fdbca2a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fdbca2a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/ThankYouPage.vue
// module id = 1901
// module chunks = 0